import { render, staticRenderFns } from "./HIRadio.vue?vue&type=template&id=5f81c808"
import script from "./HIRadio.vue?vue&type=script&lang=js"
export * from "./HIRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports